(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'emotion'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('emotion'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.emotion);
    global.index = mod.exports;
  }
})(this, function (exports, _emotion) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.styleLoader = exports.calculateRgba = undefined;
  var calculateRgba = exports.calculateRgba = function calculateRgba(color, opacity) {
    if (color[0] === '#') {
      color = color.slice(1);
    }

    if (color.length === 3) {
      var res = '';
      color.split('').forEach(function (c) {
        res += c;
        res += c;
      });
      color = res;
    }

    var rgbValues = color.match(/.{2}/g).map(function (hex) {
      return parseInt(hex, 16);
    }).join(', ');
    return 'rgba(' + rgbValues + ', ' + opacity + ')';
  };

  var styleLoader = exports.styleLoader = function styleLoader(defaultStyle, loaderStyle) {
    if (Object.keys(loaderStyle).length === 0) {
      return defaultStyle;
    } else {
      return (0, _emotion.cx)(defaultStyle, /*#__PURE__*/(0, _emotion.css)(loaderStyle));
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/react-spinners/dist/helpers/index.js
// module id = 40
// module chunks = 168707334958949